import PhoneIcon from '@mui/icons-material/Phone'
import { routeBackOfficeAllEntityAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAllEntityAdminCommon'
import { routeBackOfficeStudentAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeStudentAdminCommon'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

const getBackOfficeGroupCall = [
  ...routeBackOfficeAllEntityAdminCommon,
  ...routeBackOfficeStudentAdminCommon,
  // Base de procédures en LECTURE pour les téléconseillers (CDC procédures, P-02/D-C) :
  // ils la consultaient déjà via le deep-link du mail de publication et l'onglet du
  // dashboard — le menu ne fait que rendre l'accès visible. MÊME nom de route et MÊME
  // href que l'entrée du menu admin (getBackOfficeGroupCallCenterAdmin) : withAuthSync
  // CUMULE les rôles des deux déclarations, et le menu dédoublonne par href+route (pas
  // de doublon pour un admin procédures). L'écriture reste portée par les pages
  // new/edit, déclarées côté admin uniquement.
  {
    route: 'callProcedures',
    menuGroup: MENU_GROUPS.CALL_CENTER,
    text: 'Base de connaissance',
    icon: PhoneIcon,
    href: '/backoffice/call/procedures',
    menuHeader: true,
    position: 400,
  },
  // NB : « Mes attestations & formations » est porte par
  // routeBackOfficeAllEntityAdminCommon (inclus ci-dessus) depuis P-14.
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_PHARMEDICALL_ADMIN],
}))

export default getBackOfficeGroupCall
